import React, { useState, useEffect } from 'react';
import AddEditItemVariationModel from './AddEditItemVariationModel';
import DataTableItmVariation from './DataTableItmVariation';
import { getItemVariationService, deleteItemVariationService } from '@/services/ItemVariationServices';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import ToastMe from '@/components/ui/ToastMe';
import Swal from 'sweetalert2';

const VariationsTabs = ({ dataSource }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [editDataId, setEditDataId] = useState('');
    const [itemVariationDataSource, setItemVariationDataSource] = useState([]);
    const [itemVariationTotal, setItemVariationTotal] = useState(0);
    const [openItemVariationModel, setOpenItemVariationModel] = useState(false);
    const [itemVariationFilter, setItemVariationFilter] = useState({
        search: '',
        page: 1,
        limit: 10,
        extra_filter: {},
    });
    const tableItmVariationColumn = [
        { name: 'Name', isIncludePrint: true },
        { name: 'Additional Price', isIncludePrint: true },
        { name: 'Status', isIncludePrint: true },
        { name: 'Action', isIncludePrint: false },
    ];

    useEffect(() => {
        if (dataSource?._id && dataSource?._id != '') {
            getRetryData();
        }
    }, [dataSource?._id]);

    const onChangeItemVariationFilter = (name, value) => {
        setItemVariationFilter({ ...itemVariationFilter, [name]: value });
    };

    const getRetryData = () => {
        getItemAttributesData(dataSource?._id);
    };

    const getItemAttributesData = (itemId) => {
        setIsLoading(true);
        setItemVariationFilter({ ...itemVariationFilter, extra_filter: { item_id: itemId } });
        dispatch(getItemVariationService({ ...itemVariationFilter, extra_filter: { item_id: itemId } }))
            .then((res) => {
                setItemVariationDataSource(res?.data?.data?.data);
                setItemVariationTotal(res?.data?.data?.total);

                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const handleEditOpen = (editId) => {
        if (editId && editId != '') {
            setEditDataId(editId);
        } else {
            setEditDataId('');
        }
        setOpenItemVariationModel(true);
    };

    const deleteRecord = (deleteId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                dispatch(deleteItemVariationService(deleteId))
                    .then((res) => {
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'Your record has been deleted.',
                            icon: 'success',
                        });
                        getItemAttributesData(dataSource?._id);
                        setIsLoading(false);
                    })
                    .catch(({ message, errorData, statusCode }) => {
                        validationErrors(errorData, message);
                        setIsLoading(false);
                    });
            }
        });
    };

    return (
        <>
            <button type="button" onClick={() => setOpenItemVariationModel(true)} className={'db-btn h-[37px] text-white bg-primary mb-5'}>
                <i className={'lab lab-add-circle-line'}></i>
                Add Variation
            </button>
            <DataTableItmVariation
                isLoading={isLoading}
                tableColumn={tableItmVariationColumn}
                dataSource={itemVariationDataSource}
                totalRecord={itemVariationTotal}
                dataFilter={{
                    search: '',
                    page: 1,
                    limit: 100,
                    extra_filter: { item_id: dataSource?._id },
                }}
                handleEditOpen={handleEditOpen}
                deleteRecord={deleteRecord}
                onChangePage={onChangeItemVariationFilter}
            />
            <AddEditItemVariationModel
                modelTitle={'Item Variation'}
                getTableData={getRetryData}
                openModel={openItemVariationModel}
                setOpenModel={setOpenItemVariationModel}
                editDataId={editDataId}
                itemId={dataSource?._id}
            />
        </>
    );
};

export default VariationsTabs;
